<template>
  <b-navbar toggleable="lg" class="navbar-bee sticky-top">
    <b-navbar-brand class="mr-0">
      <router-link to="/">
        <img
          class="app__logo"
          src="../assets/images/ap8logo.svg"
          alt="Logo adpotuj"
        />
      </router-link>
    </b-navbar-brand>
    <div class="form__show d-lg-none" v-b-modal="'modal-payment'">
      ADOPTUJĘ <font-awesome-icon :icon="['fas', 'angle-double-right']" />
    </div>

    <b-navbar-toggle target="nav-collapse">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <li class="nav-item">
          <router-link class="nav-link d-lg-none" to="/"
            >Strona główna
          </router-link>
        </li>
        <b-nav-item id="about-nav" @click="toggleQA('about')"
          >O Akcji</b-nav-item
        >
        <b-nav-item
          id="bees-and-climate-nav"
          @click="toggleQA('bees-and-climate')"
          >O zapylaczach</b-nav-item
        >
        <b-nav-item
          href="https://podsumowanie.adoptujpszczole.pl"
          target="_blank"
          >Co robimy</b-nav-item
        >
        <b-nav-item
          id="pakiet-pszczelego-bohatera-nav"
          @click="toggleQA('pakiet-pszczelego-bohatera-mp')"
          >Pakiet Pszczelego Bohatera</b-nav-item
        >

        <div class="font-icon">
          <div
            v-if="regularFont"
            title="Czcionka średnia"
            @click="toggleMiddleFontView()"
          >
            <img
              src="../assets/images/font-plus.svg"
              alt="Czcionka średnia ikona"
            />
          </div>

          <div
            v-if="middleFont"
            title="Czcionka duża"
            @click="toggleBigFontView()"
          >
            <img
              src="../assets/images/font-plus.svg"
              alt="Czcionka duża ikona"
            />
          </div>

          <div
            v-if="bigFont"
            title="Czcionka domyślna"
            @click="toggleRegularFontView()"
          >
            <img
              src="../assets/images/font-minus.svg"
              alt="Czcionka domyślna ikona"
            />
          </div>
        </div>
        <div
          class=" contrast-icon"
          title="Kontrast żółto-czarny"
          @click="toggleShowContrast()"
        >
          <img
            src="../assets/images/font-contrast.svg"
            alt="Kontrast żółto-czarny ikona"
            class="mb-1"
          />
        </div>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      title: "Navigacja",
      regularFont: true,
      middleFont: false,
      bigFont: false,
    };
  },
  components: {},

  methods: {
    scrollToElement(id) {
      let positionOfElement = document.getElementById(id).offsetTop;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: positionOfElement + 575,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: positionOfElement,
          left: 0,
          behavior: "smooth",
        });
      }
    },

    toggleShowContrast() {
      this.$emit("show-contrast-view");
    },
    toggleRegularFontView() {
      this.$emit("show-regular-font-view");
      this.regularFont = true;
      this.middleFont = false;
      this.bigFont = false;
    },
    toggleMiddleFontView() {
      this.$emit("show-middle-font-view");
      this.regularFont = false;
      this.middleFont = true;
      this.bigFont = false;
    },
    toggleBigFontView() {
      this.$emit("show-big-font-view");
      this.regularFont = false;
      this.middleFont = false;
      this.bigFont = true;
    },
    toggleQA: function(el) {
      let element = document.getElementById(el);
      console.log('el', el)
      if (typeof element != "undefined" && element != null) {
        this.scrollToElement(el);
      } else {
         console.log('else')
        if (el == "about") {
          this.$router.push("/pytania-i-odpowiedzi/o-akcji");
        } else if (el == "bees-and-climate") {
          this.$router.push("/pytania-i-odpowiedzi/dlaczego-zapylacze");
        } else if (el == "pakiet-pszczelego-bohatera-mp") {
          console.log('sasas')
          this.$router.push("/pytania-i-odpowiedzi/pakiet-pszczelego-bohatera");
        } else {
          console.log("element", element, el);
          this.$router.push("/pytania-i-odpowiedzi").catch(() => {});
        }
      }
    },
  },
};
</script>
<style lang="scss">
.font-icon,
.contrast-icon {
  display: none;
  @media (min-width: 1200px) {
    display: block;
    color: #ffc501;
    background-color: #313131;
    position: fixed;
    left: 0;
    z-index: 999;
    width: 2.4rem;
    font-size: 1.35rem;
    padding: 0.25rem 0.35rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &:hover {
    cursor: pointer;
  }
  a {
    color: #ffc501;
  }
  a:active,
  a:visited {
    cursor: pointer;
    color: #ffc501;
  }
}
.font-icon {
  top: calc(50vh - 5rem);
}
.contrast-icon {
  top: calc(50vh - 2rem);
}
</style>
